import React from "react";

interface IProps extends React.HTMLAttributes<HTMLElement> {
  className: string;
}

const Icon: React.FC<IProps> = ({ className, ...props }) => (
  <i {...props} className={className} />
);

export default Icon;
